export default {
  id: null,
  cooperativa: null,
  cooperativaContato: null,
  emailContato: null,
  telefoneContato: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/contactexternalmodel.js